import { IconContent } from '@icons';

export const orders: IconContent = {
    md: '<path d="M5 3H4v18h16V3H5Zm0 1h14v16H5V4Zm12 3V6h-7v1h7ZM9 6v1H7V6h2Zm3.5 4V9h-1v1H9.92l-.5.5v3l.5.5h3.66v2H9.5v1h2v1h1v-1h1.58l.5-.5v-3l-.5-.5h-3.66v-2h4.08v-1h-2Z" />',
};
